// import { InnerBlocks } from "@wordpress/block-editor";
import { useContext } from "react";
import { Attribute, AttributeGroup, AttributeProperty, ComponentProps, Container, ContainerAttributes } from "react-builder";
import {
    Route
} from "react-router-dom";
import LoginForm from "../components/LoginForm";
import { AuthContext } from "react-builder";
import { Params } from "react-builder";
import { ProductServerAuthContext } from "../providers/ProductServerAuth";

@AttributeGroup({
    blockName: 'ProductHomepagePage', title: 'Homepage - Page',
})
export class HomepagePageAttributes extends Attribute {

    @AttributeProperty({ type: 'Boolean' })
    requiresLogin: boolean = false;
    @AttributeProperty({ type: 'String' })
    path: string = '';
    @AttributeProperty({ type: 'Object', exportCssPropertyToWrapper: true })
    container: ContainerAttributes = new ContainerAttributes().fromJSON({ margin: 'auto', maxWidth: '1200px', padding: '20px' });
}

function ProductHomepagePage(props: ComponentProps<HomepagePageAttributes>) {

    const { isLoggedIn } = useContext(AuthContext);
    const authNew = useContext(ProductServerAuthContext);


    return (
        // <HashRouter>
        <Route exact path={'/' + props.attributes.path} render={({ location }) => {

            return (!props.attributes.requiresLogin || (authNew?.isLoggedIn || isLoggedIn)) ? <Params><Container attributes={props.attributes.container} >{props.children}</Container></Params> :

                <div style={{ margin: 'auto', textAlign: 'center', padding: '20px' }}>
                    <h2>Login required</h2>
                    <LoginForm style={{ margin: 'auto' }} ></LoginForm>
                </div>
            // <Redirect
            //     to={{
            //         pathname: "/",
            //         state: { from: location }
            //     }}
            // />
        }} >

        </Route>
        // </HashRouter>
    )
}

ProductHomepagePage.example = {

    attributes: {
        path: ''
    },
    innerBlocks: [
        {
            name: 'core/paragraph',
            attributes: {
                /* translators: example text. */
                content: 'This is a homepage page',
            },
        },
    ],
}

// ProductHomepagePage.attributes = {

//     path: {
//         type: 'string',
//         default: ''
//     },
// }
ProductHomepagePage.prototype.Props = HomepagePageAttributes;

export default ProductHomepagePage;